import {
    type SendPasswordResetLinkToUsersResponseType,
    type SendPasswordResetLinkToUsersRequestType
} from "./type";
import {
    request
} from "../request";

const sendPasswordResetLinkToUsers = async (
    params: SendPasswordResetLinkToUsersRequestType
): Promise<SendPasswordResetLinkToUsersResponseType> => {
    return await request<SendPasswordResetLinkToUsersResponseType>(
        "/user/sendPasswordResetLinkToUsers",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};

export default sendPasswordResetLinkToUsers;
